import { render, staticRenderFns } from "./section-member.vue?vue&type=template&id=5188b776&"
import script from "./section-member.vue?vue&type=script&lang=js&"
export * from "./section-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports